import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ComponentRendering, Placeholder, ComponentFields } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';

const SS_STANDARD_PADDINGS = 'py-8 md:pt-15 md:pb-20';
const SS_OUTER_OFFSET = '-left-4 md:-left-8 xl:-left-25';
const SS_INNER_WRAP_CLASSES = 'px-4 md:px-8 xl:px-25 w-full md:max-w-screen xl:max-w-[1144px]';


export default /*@__PURE__*/_defineComponent({
  __name: 'FullBleedSection',
  props: {
    rendering: {},
    fields: {}
  },
  setup(__props: any) {

const props = __props;

const outerWrapperClass = computed(() => {
  const outer = props.rendering?.params?.outerOffsetClass || SS_OUTER_OFFSET;
  const background = props.rendering?.params?.backgroundClass || 'bg-racq-neutral-grey';
  return `${SS_STANDARD_PADDINGS} ${outer} ${background}`.trim();
});

//defaults to self service jss-ss-main container style layout
const innerWrapperClass = computed(() => props.rendering?.params?.innerWrapperClass || SS_INNER_WRAP_CLASSES);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-screen lg:max-w-[calc(100vw-304px)] relative", [outerWrapperClass.value]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(innerWrapperClass.value)
    }, [
      _createVNode(_unref(Placeholder), {
        name: "jss-ss-main-container",
        rendering: _ctx.rendering
      }, null, 8, ["rendering"])
    ], 2)
  ], 2))
}
}

})